import React, { useState } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Button, Icon, Loading, WithTooltip } from '../Elements';
import { getExport } from './getExport';

import classes from './ExportButton.module.scss';

const ExportButton = ({ exportConfig, isDisabled = false, changeOptions }) => {
  const [loader, setLoader] = useState(false);

  const { t } = useTranslation(['activity']);

  const createREQ_BODY = changeOptions => {
    let REQ_BODY = {
      fieldsToExport: '*'
    };
    let arrOptions = [];
    changeOptions.forEach(item => {
      if (item.show && item.valuesExport) {
        item.valuesExport.forEach(value => {
          arrOptions.push(value);
        });
      }
    });

    REQ_BODY = { fieldsToExport: arrOptions };

    return REQ_BODY;
  };

  const ExportFiles = exportConfig => () => {
    if (!loader) {
      const REQ_BODY = changeOptions
        ? createREQ_BODY(changeOptions)
        : undefined;
      setLoader(true);
      getExport(exportConfig.exportUrl, REQ_BODY)
        .then(response => {
          setLoader(false);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          let fileName = `${exportConfig.exportName}${moment().format(
            'YYYY_MM_DD-HH_MM'
          )}.${exportConfig.exportFormat}`;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch(err => {
          setLoader(false);
          console.log(err);
        });
    }
  };

  if (isDisabled) {
    return (
      <div className={classes.button}>
        <Icon size="16px" icon="export" className={classes.button_icon} />
      </div>
    );
  }

  return (
    <WithTooltip text="Export">
      <div className={classes.wrapper}>
        <Button
          className={cn(
            classes.button,
            classes.enabled,
            loader && classes.disabled
          )}
          onClick={ExportFiles(exportConfig)}
          aria-label={t('activity:buttons.EXPORT_BUTTON')}
        >
          {loader ? (
            <Loading size={'small'} className={classes.loader} />
          ) : (
            <Icon size="16px" icon="export" className={classes.button_icon} />
          )}
        </Button>
      </div>
    </WithTooltip>
  );
};

ExportButton.propTypes = {
  exportConfig: PropTypes.object,
  isDisabled: PropTypes.bool,
  changeOptions: PropTypes.array
};

export default ExportButton;
